module.exports = __webpack_public_path__ + "static/media/testimonial-image-01.e06ff353.png";